const { isEmpty } = require('lodash');

const { entries } = Object;

module.exports = {
  fields: () => {
    return {
      name: {
        label: '名称',
        type: 'string',
        validations: {
          required: v => !isEmpty(v),
        },
      },
      printnodePrinterId: {
        label: 'PrintNode プリンターID',
        type: 'string',
        validations: {
          required: v => !isEmpty(v),
        },
      },
    };
  },
};
